import PurchaseButton from "@/src/components/buttons/PurchaseButton";
import { Button, Typography } from "@material-tailwind/react";
import React from "react";
import SubCardIcons, { SubCardIconsProps } from "./Icons";
import { Done } from "@mui/icons-material";
import { Product, RichDescription } from ".";
import {
  CURRENT_SUBSCRIPTION_YEAR,
  SHOW_ONCE_OFF_SUBCRIPTIONS,
  SHOW_RECURRING_SUBSCRIPTIONS,
} from "@/src/constants";

export interface SubscribeCardProps {
  title: string;
  price: string;
  yearlyPrice: string;
  yearlyExpiry: string;
  desc?: string[];
  newDesc?: RichDescription[];
  highlight: string;
  link: string;
  imageURL: string;
  hero: boolean;
  index: number;
  packageId: "BBL" | "NRL" | "FULL" | string;
  priceId: string;
  isSubscribed?: boolean;
  subProducts: Product[];
  activeSubs: string[];
}

const NewCard = ({
  title,
  price,
  yearlyPrice,
  yearlyExpiry,
  desc,
  newDesc,
  highlight,
  link,
  imageURL,
  hero,
  index,
  packageId,
  isSubscribed = false,
  subProducts = [],
  activeSubs = [],
  priceId,
}: SubscribeCardProps) => {
  return (
    <div
      className={`subcard flex flex-col ${title} ${
        hero ? `hero order-1` : `order-${index}`
      }`}
    >
      <div className="flex-col flex items-start h-[100%] gap-[30px] border border-solid border-[#f3f2ed] bg-white rounded-xl px-5 sm:px-6 pt-4 md:pb-6 pb-8 ">
        <div className="hidden min-h-[100px] min-w-[100px] flex-row items-start bg-[#eee7d3] rounded-lg sm:rounded-xl"></div>
        <div className="flex-col flex items-start gap-y-[30px] h-full w-full">
          <div className="flex-col flex items-start gap-y-[30px] w-full">
            <div className="flex-col flex items-start gap-y-[24px] w-full">
              <div className="flex-col flex items-start gap-y-[14px]">
                <div className="font-bold text-base text-4xl md:text-4xl">
                  <span className={"text-scpb-light-blue font-bold slash"}>
                    /&nbsp;
                  </span>
                  {title === "SCPB Premium" && "👑 "}
                  {title}
                </div>
              </div>

              <SubCardIcons
                //@ts-ignore
                level={
                  title && (title.split(" ")[0] as unknown as SubCardIconsProps)
                }
              />
            </div>
            <div className="flex-col flex items-start gap-2 w-full">
              <div className="flex items-center w-full text-center">
                {SHOW_RECURRING_SUBSCRIPTIONS && (
                  <div className="flex flex-col w-[100%]">
                    <p className="font-bold text-5xl sm:text-5xl w-full">
                      <strong className="font-bold">{price}</strong>
                    </p>
                    <p>
                      <span className="text-sm font-thin">
                        Monthly subscription
                      </span>
                    </p>
                    <span className="text-xs font-thin">Cancel Anytime</span>
                  </div>
                )}
                {SHOW_ONCE_OFF_SUBCRIPTIONS && (
                  <div
                    className={`flex flex-col ${
                      SHOW_RECURRING_SUBSCRIPTIONS ? "w-[50%]" : "w-full"
                    }`}
                  >
                    <p className="font-bold text-5xl sm:text-5xl w-full">
                      <strong className="font-bold">{yearlyPrice}</strong>
                    </p>
                    <p>
                      <span className="text-sm font-thin">Once Off</span>
                    </p>
                    <span className="text-xs font-thin">
                      Expires {yearlyExpiry}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="min-h-[1px] min-w-full bg-[#eae7dc]"></div>
          <div className="flex-col flex items-start gap-y-4">
            <div className="font-normal text-xl sm:text-lg">
              What&#39;s included
            </div>
            <div className="flex-col flex items-start gap-y-3">
              {desc?.map(function (item, index) {
                return (
                  <div
                    className="flex-row flex items-center gap-x-3"
                    key={index}
                  >
                    <div className="flex min-h-[20px] min-w-[20px] max-w-[20px] items-center">
                      <Done
                        style={{ fontSize: "0.75rem", marginTop: "0.25rem" }}
                      />
                    </div>
                    <div className="font-normal text-sm">
                      <Typography variant="paragraph" className={"text-sm"}>
                        <span dangerouslySetInnerHTML={{ __html: item }} />
                      </Typography>
                    </div>
                  </div>
                );
              })}
              {newDesc?.map(function (item, index) {
                return (
                  <div
                    className="flex-row flex items-center gap-x-3"
                    key={index}
                  >
                    <div className="flex min-h-[20px] min-w-[20px] max-w-[20px] items-center">
                      <Done
                        style={{ fontSize: "0.75rem", marginTop: "0.25rem" }}
                      />
                    </div>
                    <div className="font-normal text-sm">
                      <Typography variant="paragraph" className={"text-sm"}>
                        <span
                          dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                      </Typography>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {process.env.NEXT_PUBLIC_SHOW_RECURRING_SUBSCRIPTION === "true" && (
            <>
              <div className="buttonContainer flex mt-[auto] w-full">
                {!activeSubs.includes(packageId) ? (
                  <PurchaseButton
                    className={"flex mt-[auto] bg-scpb-light-blue w-full"}
                    onClick={() => {}}
                    packageId={packageId}
                    priceId={priceId}
                  />
                ) : (
                  <Button disabled={true} className="w-full">
                    Purchased
                  </Button>
                )}
              </div>
            </>
          )}

          <div className="flex flex-col gap-2 w-full mt-auto">
            {subProducts.map(function (sp: Product) {
              if (activeSubs.includes(sp.id)) {
                return (
                  <Button disabled className="w-full" key={sp.id}>
                    {sp.description} Purchased
                  </Button>
                );
              } else {
                return (
                  <PurchaseButton
                    key={sp.id}
                    className={"mt-[auto] bg-scpb-light-blue"}
                    onClick={() => {}}
                    packageId={sp.id}
                    price={sp.price}
                    priceId={sp.priceId}
                    description={sp.description}
                    purchaseType="one-off"
                  />
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewCard;
